import { createComponentHealth } from '@shared/components/ComponentHealth';

export const [wrapWithReturnPolicyHealthProvider, useReturnPolicyHealth] = createComponentHealth('ReturnPolicy');
